import React from 'react';
import {cx} from 'emotion';
import styled from 'react-emotion';
import {Dimmer, Loader} from 'semantic-ui-react';

const DimmableWrapper = styled(props => <Dimmer.Dimmable {...props} />)`
  &.transparent {
    .ui.inverted.dimmer {
      background-color: transparent;
    }
  }

  &.hideContentWhenLoading {
    min-height: 200px;
  }
`;

const LoadingContainer = ({
  children,
  loading,
  hideContentWhenLoading,
  transparent,
  message = 'Loading...',
  className,
  ...props
}) => {
  return (
    <DimmableWrapper dimmed={loading} {...props} className={cx(className, {hideContentWhenLoading, transparent})}>
      {loading && hideContentWhenLoading ? null : children}
      <Dimmer active={loading} inverted>
        <Loader>{message}</Loader>
      </Dimmer>
    </DimmableWrapper>
  );
};

export default LoadingContainer;
